mutation DeleteContactLists($ids: [ID!]!) {
  deleteContactLists(ids: $ids) {
    id
  }
}
